import { Underground } from './Underground';
import { IUnderground } from '../../types';

export interface IUndergroundsProps {
  regionId: number;
  undergrounds: IUnderground[];
}

export function Undergrounds({ regionId, undergrounds }: IUndergroundsProps) {
  return (
    <>
      {undergrounds.map(underground => {
        const { id, ...rest } = underground;

        return <Underground key={id} regionId={[regionId]} {...rest} />;
      })}
    </>
  );
}
